const BASE = 13;
const MIN_SIZE = 7;

export const calculateDynamicFontSize = (text: string): string => {
  const textLength = text.length;
  const result = Math.ceil(BASE * (1 - text.length / 100) * (BASE / textLength));

  return `${result < MIN_SIZE ? MIN_SIZE : result > BASE ? BASE : result}px`;
};
